import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import { YoyBars, fmtK, type YoYData } from '@/features/bi/shared';
import { IconDollar } from '@/components/ui/Icon';
import { registerWidget } from '../registry';
import { CHART } from '../homeStyles';

function PnlYoyRender() {
  const year = new Date().getFullYear();
  const q = useQuery({
    queryKey: ['home-yoy', year],
    queryFn: () => api.get<YoYData>(`/bi/yoy?year=${year}`),
  });
  const rows = q.data?.rows ?? [];
  return (
    <YoyBars data={rows} keyCy="revenue_cy" keyPy="revenue_py" year={year} M={fmtK} barColor={CHART.series} tools={false} />
  );
}

function NoConfig() { return null; }

registerWidget({
  type: 'pnl_yoy',
  label: 'Revenue — this year vs last',
  defaultSize: 'M',
  hideFromPicker: true,
  icon: <IconDollar size={13} />,
  accent: '#0d9488',
  nodeFor: () => 'ledger.profit_loss',
  ConfigForm: NoConfig,
  Render: PnlYoyRender,
});
